
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rankpredictor/[goalSlug]/[goalUID]",
      function () {
        return require("private-next-pages/rankpredictor/[goalSlug]/[goalUID].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rankpredictor/[goalSlug]/[goalUID]"])
      });
    }
  